import React, {useState} from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Avatar,
  Typography,
  IconButton,
  Button, Modal, Container
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { Star } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { addBookmark, removeBookmark } from "../../../../../redux/firebaseCalls";

const useStyles = makeStyles((theme) => ({
  star: {
    position: "absolute",
    zIndex: 2,
    top: theme.spacing(1),
    right: theme.spacing(1),
    // left: theme.spacing(1),
  },
  starIcon: {
    color: (props) => (props.bookmark ? "#F6BE00" : "grey"),
  },
  cardMedia: {
    height: theme.spacing(10),
  },
  avatar: {
    position: "absolute",
    left: 0,
    right: 0,
    marginLeft: "auto",
    marginRight: "auto",
    top: theme.spacing(5),
    height: theme.spacing(10),
    width: theme.spacing(10),
  },
  content: {
    marginTop: theme.spacing(4),
  },
  modalContainer: {
    position: "absolute",
    width: 500,
    height: 200,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
  },
  modalButtonDiv: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(5)
  },
}));

export default function InfoCard({ code, name, image, uid }) {
  const dispatch = useDispatch();
  const bookmarkUniv = useSelector((state) => state.bookmark.bookmarkList);
  const [bookmark, setBookmark] = useState(bookmarkUniv.includes(name));
  const [openModal, setOpenModal] = useState(false);
  const classes = useStyles({bookmark});
  const history = useHistory();

  const handleCardClick = (univName) => {
    history.push(`/univinfo/${univName.replaceAll(" ", "-")}`);
  };

  const handleRemove = () => {
    setBookmark(false);
    removeBookmark(name, uid, dispatch);
    setOpenModal(false);
  };

  const handleBookmark = () => {
    if (!bookmark) {
      setBookmark(true);
      addBookmark(name, uid, dispatch);
    } else {
      setOpenModal(true);
    }
  };

  return (
    <>
    <Card style={{position:"relative"}}>
      <IconButton className={classes.star} style={{ backgroundColor: "white" }} onClick={handleBookmark}>
        <Star className={classes.starIcon} />
      </IconButton>
      <CardActionArea style={{position: "relative"}} onClick={() => handleCardClick(name)}>
        <Avatar className={classes.avatar}>{code}</Avatar>
        <CardMedia className={classes.cardMedia} title={name} image={image} />
        <CardContent className={classes.content}>
          <Typography variant="body1" align="center">
            {name}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
    <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Container className={classes.modalContainer}>
          <Typography variant="h5">
            Are you sure you want to remove this university from your bookmarked
            list?
          </Typography>
          <div className={classes.modalButtonDiv}>
            <Button
              color="secondary"
              variant="contained"
              style={{marginRight: 10}}
              onClick={handleRemove}
            >
              Proceed
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </Button>
          </div>
        </Container>
      </Modal>
    </>
  );
}
